import { Outlet } from "react-router-dom";

export default function AnonymousLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
